import {
    WorkflowCredentialsType,
    IntegrationCopyCMSType,
    DataMode,
    ImageDeployment,
    CodeSnippetEnv,
    VideoDeployment
} from "./types";
import { generateWorkflowCodeSnippet } from "./workflows/generateWorkflowCodeSnippet";

export const generateIntegrationCMS = (
    workflowCredentials: WorkflowCredentialsType
): IntegrationCopyCMSType => {
    return {
        [DataMode.IMAGE]: {
            [ImageDeployment.SINGLE]: {
                title: "Single Image (Cloud)",
                icon: "fas fa-cloud",
                codeSnippets: [
                    {
                        description: (
                            <p>
                                You can pass input images as type <code>url</code> or{" "}
                                <code>base64</code>:
                            </p>
                        ),
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    },
                    {
                        description: (
                            <div className="flex w-full flex-col gap-2">
                                <p>First, install the Roboflow Inference Python SDK:</p>
                                <code className="rounded-md bg-gray-100 p-4">
                                    <span style={{ color: "#cf222e" }}>pip install</span>{" "}
                                    inference-sdk
                                </code>
                                <p>Then, use the following code snippet to run your model:</p>
                            </div>
                        ),
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.PYTHON,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.PYTHON
                    },
                    {
                        description: (
                            <p>
                                You can pass input images as type <code>url</code> or{" "}
                                <code>base64</code>:
                            </p>
                        ),
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.JAVASCRIPT,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.JAVASCRIPT
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            },
            [ImageDeployment.MULTIPLE]: {
                title: "Multiple Images (Cloud)",
                icon: "far fa-cloud",
                codeSnippets: [
                    {
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    },
                    {
                        description: (
                            <p>
                                After running <code>pip install -U inference-sdk</code>:
                            </p>
                        ),
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.PYTHON,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.PYTHON
                    },
                    {
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.JAVASCRIPT,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.JAVASCRIPT
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            },
            [ImageDeployment.EDGE]: {
                title: "Edge Detection",
                icon: "fal fa-microchip",
                codeSnippets: [
                    {
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    },
                    {
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.PYTHON,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.PYTHON
                    },
                    {
                        code: generateWorkflowCodeSnippet(
                            CodeSnippetEnv.JAVASCRIPT,
                            workflowCredentials
                        ),
                        env: CodeSnippetEnv.JAVASCRIPT
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            }
        },
        [DataMode.VIDEO]: {
            [VideoDeployment.FILE]: {
                title: "File",
                icon: "far fa-file",
                codeSnippets: [
                    {
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            },
            [VideoDeployment.EDGE]: {
                title: "Edge Detection",
                icon: "fal fa-microchip",
                codeSnippets: [
                    {
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            },
            [VideoDeployment.STREAM]: {
                title: "Stream",
                icon: "far fa-stream",
                codeSnippets: [
                    {
                        code: generateWorkflowCodeSnippet(CodeSnippetEnv.CURL, workflowCredentials),
                        env: CodeSnippetEnv.CURL
                    }
                ],
                documentationUrl: "https://docs.roboflow.com/deploy/serverless"
            }
        }
    };
};
